module.exports = __webpack_public_path__ + "static/img/dadi.ba1b336.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/dadi.png
// module id = VE1U
// module chunks = 1